import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer = () => {
  return (
    <footer className="webpage-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/web/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
          <span className="footer-copyright">
            © {new Date().getFullYear()} Neonimble.ai - All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;